/*
 * CarCreator Messages
 *
 * This contains all the text for the Car Creator container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.CarCreator';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Caratteristiche Auto',
  },
  category: {
    id: `${scope}.category`,
    defaultMessage: 'Categoria',
  },
  fuel: {
    id: `${scope}.fuel`,
    defaultMessage: 'Allimentazione',
  },
  modello: {
    id: `${scope}.modello`,
    defaultMessage: 'Modello',
  },
  allestimento: {
    id: `${scope}.allestimento`,
    defaultMessage: 'Allestimento',
  },
  neo_patentati: {
    id: `${scope}.neo_patentati`,
    defaultMessage: 'Neopatentati',
  },
  segmento: {
    id: `${scope}.segmento`,
    defaultMessage: 'Segmento',
  },
  cilindrata: {
    id: `${scope}.cilindrata`,
    defaultMessage: 'Cilindrata',
  },
  cavalli_fiscali: {
    id: `${scope}.cavalli_fiscali`,
    defaultMessage: 'Cavalli',
  },
  descrizione_trazione: {
    id: `${scope}.descrizione_trazione`,
    defaultMessage: 'Trazione',
  },
  desc_motore: {
    id: `${scope}.desc_motore`,
    defaultMessage: 'Motore',
  },
  hp: {
    id: `${scope}.hp`,
    defaultMessage: 'HP',
  },
  kw: {
    id: `${scope}.kw`,
    defaultMessage: 'KW',
  },
  euro: {
    id: `${scope}.euro`,
    defaultMessage: 'Euro',
  },
  emissioni_co2: {
    id: `${scope}.emissioni_co2`,
    defaultMessage: 'Emissioni CO2',
  },
  consumo_medio: {
    id: `${scope}.consumo_medio`,
    defaultMessage: 'Consumo Medio',
  },
  descrizione_cambio: {
    id: `${scope}.descrizione_cambio`,
    defaultMessage: 'Tipo di Cambio',
  },
  lunghezza: {
    id: `${scope}.lunghezza`,
    defaultMessage: 'Lunghezza',
  },
  larghezza: {
    id: `${scope}.larghezza`,
    defaultMessage: 'Larghezza',
  },
  bagagliaio: {
    id: `${scope}.bagagliaio`,
    defaultMessage: 'Bagagliaio',
  },
  posti: {
    id: `${scope}.posti`,
    defaultMessage: 'Posti',
  },
  porte: {
    id: `${scope}.porte`,
    defaultMessage: 'Porte',
  },
  submit: {
    id: `${scope}.submit`,
    defaultMessage: 'Salva',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Annulla',
  },
  close: {
    id: `${scope}.close`,
    defaultMessage: 'Chiudi',
  },
});
